<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="selector-body">
		<!-- 				 -->
		<!-- School Selector -->
		<!-- 				 -->
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchool"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r">{{r.SchoolNumber}} - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
				</caass-schoolselector>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleActive()">Toggle Active</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total printers: {{ lstPrinters.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<!-- 					  -->
<!-- Display PrintQ Items -->
<!-- 					  -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->

	<p-table
		#mydt
		[value]="lstPrinters"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPrinter"
		dataKey="IDPrinterID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<ng-template pTemplate="header">
			<tr style="height: 4rem">
				<th style="width: 3rem">
					<!-- 				   -->
					<!-- Display When Busy -->
					<!-- 				   -->
					<div [style.display]="isBusy == true ? 'block' : 'none'">
						<img class="busy-img" src="assets/images/loading.gif" />
					</div>
				</th>

				<!-- <th style="width: 3rem"> <p-tableHeaderCheckbox></p-tableHeaderCheckbox></th> -->
				<th pSortableColumn="Active" class="fixwidth-07">Active<p-sortIcon field="Active"></p-sortIcon></th>
				<th pSortableColumn="PrinterName">Printer Name<p-sortIcon field="PrinterName"></p-sortIcon></th>
				<th pSortableColumn="ScanStation">Station Name<p-sortIcon field="ScanStation"></p-sortIcon></th>
				<th pSortableColumn="FacilityName">Facility Name <p-sortIcon field="FacilityName"></p-sortIcon></th>
				<th pSortableColumn="c_date">Status Date<p-sortIcon field="c_date"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rPrinterItem>
			<tr [pSelectableRow]="rPrinterItem">
				<td>
					<div>
						<!-- <p-tableCheckbox [value]="rPrinterItem"></p-tableCheckbox> -->
					</div>
				</td>

				<td>
					<div class="fixwidth-07">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-active': rPrinterItem.Active,
								'pi-ban table-inactive': !rPrinterItem.Active
							}"
						></i>
					</div>
				</td>

				<td>
					<div class="table-data-printer">
						{{ rPrinterItem.PrinterName }}
					</div>
				</td>

				<td>
					<div class="table-data-printer">
						{{ rPrinterItem.ScanStation }}
					</div>
				</td>

				<td>
					<div class="table-data-printer">
						{{ rPrinterItem.FacilityName }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrinterItem.c_dateDesc }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						  -->
<!-- Display When No Printers -->
<!-- 					      -->
<div style="padding: 20px" [style.display]="lstPrinters.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No printers configured...</label>
</div>

<!-- 					  -->
<!-- Delete Error Message -->
<!-- 					  -->
<div style="padding: 20px; color: #e61010" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
	<label>{{ ErrorMessage }}</label>
</div>
